import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { FolderOpenIcon, PaperAirplaneIcon } from "@heroicons/react/outline";
import { DocumentVisibility } from "./supportingMetadata";

export const DocumentAudienceSection = ({
  visibility,
  children,
}: {
  visibility: DocumentVisibility;
  children: ReactNode;
}) => {
  const { t } = useTranslation();
  const Icon = visibility === "external" ? PaperAirplaneIcon : FolderOpenIcon;
  return (
    <section
      className="mt-6 overflow-hidden rounded-xl border border-gray-200 bg-white"
      aria-label={t(`documentLibrary.sections.${visibility}`)}
    >
      <div className="flex items-center gap-3 border-b border-gray-100 bg-cyan-50 px-5 py-4">
        <Icon className="h-5 w-5 flex-shrink-0 text-cyan-700" />
        <div>
          <h2 className="text-sm font-semibold text-gray-900">
            {t(`documentLibrary.sections.${visibility}`)}
          </h2>
          <p className="mt-0.5 text-xs text-gray-500">
            {t(`documentLibrary.sectionHints.${visibility}`)}
          </p>
        </div>
      </div>
      <div className="space-y-3 p-3 sm:p-4">{children}</div>
    </section>
  );
};
